import { z } from 'my-zod'

export const ActionPlanTriggerTypeEnum = z.enum(['Manual', 'ManualWithOutfitters'])

export const ActionPlanOwnerTypeEnum = z
  .enum(['User', 'AccountSpecialist', 'RiskSpecialist', 'AdventuresFleetManager', 'ServiceOps'])
  .setEnumLabels({
    User: 'User',
    RiskSpecialist: 'Risk Specialist',
    AccountSpecialist: 'Account Manager',
    AdventuresFleetManager: 'Adventures Fleet Manager',
    ServiceOps: 'Service Ops'
  })

export const ActionPlanStatusTypeEnum = z.enum(['NotStarted', 'InProgress', 'Complete'])
export const ActionPlanTaskStatusTypeEnum = ActionPlanStatusTypeEnum.setEnumLabels({
  NotStarted: 'Not Started',
  InProgress: 'In Progress',
  Complete: 'Complete'
})
